import styled from 'styled-components';

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #333;
`;

export const ModalFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
